import classNames from "classnames";
import React, { Component } from "react";
import { isMobile } from "react-device-detect";
import { Trans, withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { reviewDeleteValidateSubmit } from "validations/review.delete.validate";
import { JAVASCRIPT_VOID } from "constant/config";

class ReviewDelete extends Component {
	constructor(props) {
		super(props);
		this.state = {
			error: false,
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.error && this.props.error !== nextProps.error) {
			this.setState({
				error: true,
			});
		}
	}

	/**
	 * 닫기
	 */
	handleClose = () => {
		if (this.props.close) {
			this.props.close();
		}
	};

	render() {
		const { t, vod, handleSubmit } = this.props;
		const { error } = this.state;
		if (isMobile) {
			return (
				<form
					onSubmit={handleSubmit}
					onClick={(e) => {
						e.stopPropagation();
						e.nativeEvent.stopImmediatePropagation();
					}}
				>
					<Field name="title_no" type="hidden" component="input" />
					<Field name="title_no_list" type="hidden" component="input" />
					<Field name="station_no" type="hidden" component="input" />
					<Field name="del_type" type="hidden" component="input" />
					<Field name="path" type="hidden" component="input" />
					<div className="ui-pop-m vod-delete">
						<div className="pop-body">
							<h2>
								<Trans>다시보기 VOD를 삭제하시겠습니까?</Trans>
							</h2>
							<Field name="del_reason" type="text" component="textarea" placeholder={t("삭제 사유를 입력해주세요.")} />
							<p className={classNames("guide_text", { error: error })}>
								<Trans>삭제 사유는 5자 ~ 200자까지 입력 가능합니다.</Trans>
							</p>
						</div>
						<div className="pop-btn">
							<a href={JAVASCRIPT_VOID} className="btn" onClick={this.handleClose}>
								<Trans>취소</Trans>
							</a>
							<button type="submit" className="btn">
								<Trans>삭제</Trans>
							</button>
						</div>
					</div>
				</form>
			);
		} else {
			return (
				<form
					onSubmit={handleSubmit}
					onClick={(e) => {
						e.stopPropagation();
						e.nativeEvent.stopImmediatePropagation();
					}}
				>
					<Field name="title_no" type="hidden" component="input" />
					<Field name="title_no_list" type="hidden" component="input" />
					<Field name="station_no" type="hidden" component="input" />
					<Field name="del_type" type="hidden" component="input" />
					<Field name="path" type="hidden" component="input" />
					<div className="ui-pop vod-delete">
						<div className="pop-body">
							<h2>
								<sup dangerouslySetInnerHTML={{ __html: "&#147;" }} />
								<strong>{vod.title_name}</strong>
								<sup dangerouslySetInnerHTML={{ __html: "&#148;" }} />
								<span>
									<Trans>다시보기 VOD를 삭제하시겠습니까?</Trans>
								</span>
							</h2>
							<Field name="del_reason" type="text" component="textarea" placeholder={t("삭제 사유를 입력해주세요.")} />
							<p className={classNames("guide_text", { error: error })}>
								<Trans>삭제 사유는 5자 ~ 200자까지 입력 가능합니다.</Trans>
							</p>
						</div>
						<div className="pop-btn">
							<a href={JAVASCRIPT_VOID} className="btn" onClick={this.handleClose}>
								<Trans>취소</Trans>
							</a>
							<button type="submit" className="btn btn_blue">
								<Trans>삭제</Trans>
							</button>
						</div>
						<a href={JAVASCRIPT_VOID} className="pop-close" onClick={this.handleClose}>
							<span>
								<Trans>레이어 닫기</Trans>
							</span>
						</a>
					</div>
				</form>
			);
		}
	}
}

const ReviewDeleteReduxForm = reduxForm({
	form: "review_delete_form",
	onSubmit: reviewDeleteValidateSubmit,
	enableReinitialize: true,
})(ReviewDelete);

const mapStateToProps = (state, ownProps) => {
	return {
		initialValues: {
			title_no: ownProps.vod.title_no,
			title_no_list: ownProps.vod.title_no,
			station_no: state.stationReducer.stationInfo.data.station.station_no,
			del_type: 4,
			path: ownProps.path,
		},
	};
};

export default connect(
	mapStateToProps,
	undefined,
)(withTranslation()(ReviewDeleteReduxForm));
